import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import Footer from "@/components/Footer";

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const sessionId = params.get("session_id");
  const [msg, setMsg] = useState("Confirmando tu pago…");

  useEffect(() => {
    if (!sessionId) { navigate("/studio"); return; }
    let attempts = 0;
    const poll = async () => {
      attempts += 1;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          const pid = data.project_id || localStorage.getItem("jarvis_project_id");
          setMsg("Pago confirmado. Preparando tu libro…");
          navigate(`/studio/${pid}`, { replace: true });
          return;
        }
      } catch (err) {
        console.error("payment status poll failed:", err);
      }
      if (attempts >= 12) { setMsg("Seguimos confirmando. Vuelve a tu estudio; tu trabajo sigue aquí."); return; }
      setTimeout(poll, 2000);
    };
    poll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionId, navigate]);

  return (
    <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: 20, textAlign: "center" }}>
      <span className="eyebrow">Pago</span>
      <p data-testid="payment-success-msg" style={{ maxWidth: 420, fontFamily: "var(--serif)", fontSize: 24, marginTop: 12 }}>{msg}</p>
      <button className="btn btn-ghost" style={{ marginTop: 24 }} onClick={() => navigate("/studio")}>Ir a mi estudio</button>
    </div>
  );
}

export function PaymentCancel() {
  const navigate = useNavigate();
  const pid = localStorage.getItem("jarvis_project_id");
  return (
    <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      <div style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: 20, textAlign: "center" }}>
        <span className="eyebrow" style={{ color: "var(--proof)" }}>Pago no completado</span>
        <h1 className="h2" style={{ fontSize: 34, marginTop: 12 }}>No se ha cobrado nada</h1>
        <p style={{ color: "var(--muted)", marginTop: 8, maxWidth: 420 }}>Tu trabajo sigue aquí. Puedes volver cuando quieras.</p>
        <button data-testid="back-to-studio-btn" className="btn btn-primary" style={{ marginTop: 24 }} onClick={() => navigate(pid ? `/studio/${pid}` : "/studio")}>
          Volver a mi libro
        </button>
      </div>
      <Footer />
    </div>
  );
}
